<app-set-of-filters #setOfFilters [groupNames]="setOfFiltersGroupNames" *ngIf="dataSource"></app-set-of-filters>
<app-filter-history #filterHistory [saveDisabled]="!filterBuilder.validate()" [manualMode]="!showFilterButton" (activate)="filter()" (navigate)="historyNavigate($event)"></app-filter-history>
<app-filter-builder [showLexicografically]="showLexicografically" [selectedRows]="selectedRows" #filterBuilder></app-filter-builder>
<ng-container>
  <div fxLayout="row" fxLayoutGap="1rem" class="mt-2">
    <ng-container *ngIf="dataSource && showFilterButton">
      <button mat-raised-button [color]="loading ? 'simsRed' : 'sims'" [disabled]="!loading && !filterBuilder.validate()" (click)="loading ? cancel() : filter()" class="mt-2">{{ (loading ? 'cancelLoading' : 'filter') | translate }}</button>
    </ng-container>
  </div>
</ng-container>
<div *ngIf="!dataSource && noDataSourceMsgKey">{{ noDataSourceMsgKey | translate }}</div>